import { useNavigate } from '@tanstack/react-router';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { useUser } from '@/entities/auth/hooks';
import { Badge } from '@/shared/components/shadcn/badge';
import { Button } from '@/shared/components/shadcn/button';
import { useWorkspaceId } from '@/shared/hooks/use-workspace-id';

export function FreeTrialCard({ expiredAt }: { expiredAt: Dayjs }) {
  const navigate = useNavigate();
  const { user } = useUser();
  const { workspaceId } = useWorkspaceId();
  const fromNow = formatDaysUntilExpiry(expiredAt);
  if (!user) return null;

  return (
    <div className="flex flex-col gap-4 rounded-md border p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold">Upgrade plan</span>
        <Badge className="leading-none">{fromNow}</Badge>
      </div>
      <Button
        size="sm"
        onClick={() =>
          navigate({ to: '/workspace/$workspaceId/settings/plan', params: { workspaceId } })
        }
      >
        Upgrade
      </Button>
    </div>
  );
}

function formatDaysUntilExpiry(date: Dayjs): string {
  const now = dayjs();
  const days = date.diff(now, 'day');

  if (days < 0) {
    return 'Expired';
  } else if (days === 0) {
    // 1일 미만일 때는 시간 단위로 표시
    const hours = date.diff(now, 'hour');
    if (hours <= 0) {
      return 'Expired';
    } else if (hours === 1) {
      return '1 hour left';
    } else {
      return `${hours} hours left`;
    }
  } else if (days === 1) {
    return '1 day left';
  } else {
    return `${days} days left`;
  }
}
